<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="290">
      <v-card>
        <v-card-title v-bind:style="{ backgroundColor: '#1e345d', color: 'white'}">
          Reset Password
          <v-spacer></v-spacer>
          <v-btn icon @click="toggle" color='white' ><v-icon>close</v-icon></v-btn>
        </v-card-title>
       <v-card-text>
            <v-form>
              <v-text-field v-if="this.successMessage == null" v-model="user.password" label="Password" type="password"></v-text-field>
              <v-text-field v-if="this.successMessage == null" v-model="user.confirm" label="Confirm Password" type="password"></v-text-field>
              <div v-if="this.resetError != null" class="text-center error--text mt-3 mb-5 error-message">{{resetError}}</div>
              <div v-if="this.successMessage != null" class="text-center success--text mt-3 mb-5 success-message">{{successMessage}}</div>
            </v-form>
          </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn v-if="this.successMessage == null" outlined color="accent" @click="reset">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'password-reset',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    user: {
      type: Object
    }
  },
  methods: {
    reset () {
      this.resetPassword(this.user)
    },
    ...mapActions({
      resetPassword: 'account/resetPasswordAdmin'
    })
  },
  computed: {
    ...mapGetters({
      resetError: 'account/error',
      successMessage: 'account/success'
    })
  }
}
</script>
<style scoped>
  .error-message {
    height: 20px;
    font-weight: bold;
  }
</style>
